import { render, staticRenderFns } from "./PortfolioScreen.vue?vue&type=template&id=26894cae&scoped=true"
import script from "./PortfolioScreen.vue?vue&type=script&lang=js"
export * from "./PortfolioScreen.vue?vue&type=script&lang=js"
import style0 from "./PortfolioScreen.vue?vue&type=style&index=0&id=26894cae&prod&scoped=true&lang=css"
import style1 from "./PortfolioScreen.vue?vue&type=style&index=1&id=26894cae&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26894cae",
  null
  
)

export default component.exports